<template>
  <HeaderComponent :flag="0"/>
  <div class="content container">
    <div class="col-sm-12 mt-4">
      <router-view />
    </div>
  </div>
  <FooterComponent />
</template>

<script>
// import CourseFinder from './CourseFinder.vue'
import HeaderComponent from '../components/semantics/HeaderComponent.vue';
import FooterComponent from '../components/semantics/FooterComponent.vue';
export default {

  name: 'StudentHome',
  components: {
    HeaderComponent,
    FooterComponent,
  }
}
</script>
<style scoped>
.content {
  min-height: 87vh;
}
</style>